module.exports = __webpack_public_path__ + "img/mych.94fcb605.jpg";